import React from 'react';
import { Table } from 'react-bootstrap';

const TelecommutingReportFilterDataTable = ({ attendances }) => {
  const renderResult = attendance => {
    const cells = [
      { id: 'date', value: attendance.date_formatted },
      { id: 'shift', value: attendance.shift_name },
      { id: 'shift_time', value: attendance.shift },
      { id: 'attendance', value: attendance.attendance_day },
      { id: 'break', value: attendance.shift_break },
      { id: 'attendance_break', value: attendance.attendance_break },
      { id: 'telecommuting', value: attendance.telecommuting },
      { id: 'observation', value: attendance.observation }
    ];

    return (
      <tr key={attendance.date_formatted}>
        {cells.map(cell => (
          <td key={cell.id} className="text-center align-middle">
            {cell.value}
          </td>
        ))}
      </tr>
    );
  };

  const renderData = () => {
    const headers = [
      'Fecha',
      'Turno',
      'Jornada Pactada',
      'Marcas Reales',
      'Colación',
      'Marcas Colación',
      'Teletrabajo',
      'Comentario'
    ];

    return (
      <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
        <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
          <tr className="rdt_TableCol">
            {headers.map(label => (
              <th key={label} className="text-center align-middle">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{attendances?.map(attendance => renderResult(attendance))}</tbody>
      </Table>
    );
  };

  return <>{renderData()}</>;
};

export default TelecommutingReportFilterDataTable;
